import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

interface RichTextContentProps {
  html: string;
  className?: string;
}

const ALLOWED_TAGS = [
  'p', 'br', 'b', 'strong', 'i', 'em', 'u', 's', 'blockquote', 'code', 'pre',
  'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'a', 'hr',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

/**
 * Renders sanitized SOP HTML. Content is also sanitized server-side on write;
 * this is the second (render-time) line of defense against XSS.
 */
export function RichTextContent({ html, className }: RichTextContentProps) {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOWED_URI_REGEXP: /^(?:https?|mailto):/i,
      }),
    [html],
  );

  return (
    <div
      className={cn('prose prose-sm dark:prose-invert max-w-none', className)}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
